// 예전 공용 버튼. 지금은 kit/Button 의 껍데기다.
//
// 25개 화면이 이 이름으로 부르고 있어 이름은 남겨두되, 모양·크기·로딩 표시는
// 전부 공용 부품(kit/Button)이 정한다. 예전엔 여기서 직접 알약을 그리고
// 스피너 SVG 를 들고 있어서, 글자 크기가 화면 폭에 따라 14↔16px 로 흔들렸다.
//
// 새 화면은 이걸 쓰지 말고 kit 의 Button 을 직접 쓴다.
import { Button } from "@/components/kit";

const SolidButton = ({ className = "", children, loading, onClick, ...others }) => (
  <Button
    variant="primary"
    size="md"
    loading={loading}
    onClick={onClick}
    name="btn"
    className={className}
    {...others}
  >
    {children}
  </Button>
);

export default SolidButton;
